(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    // Open Clothing and Fishing Finds immediately on mouse hover.
  document.addEventListener('mouseover', function (event) {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    if (!(event.target instanceof Element)) return;
    const dropdown = event.target.closest(
      '.bnb-full-navigation__item:is([data-menu-handle="fishing-finds"], [data-menu-handle="clothing"], [data-bnb-babes], [data-bnb-contact], [data-bnb-bulk], [data-bnb-hats]) > .bnb-full-navigation__details'
    );
    if (!dropdown) return;
    if (event.relatedTarget instanceof Node && dropdown.contains(event.relatedTarget)) return;
    dropdown.open = true;
  });

  // Close either desktop dropdown as soon as the mouse leaves its label and panel.
  document.addEventListener('mouseout', function (event) {
    if (!(event.target instanceof Element)) return;
    const dropdown = event.target.closest(
      '.bnb-full-navigation__item:is([data-menu-handle="fishing-finds"], [data-menu-handle="clothing"], [data-bnb-babes], [data-bnb-contact], [data-bnb-bulk], [data-bnb-hats]) > .bnb-full-navigation__details[open]'
    );
    if (!dropdown) return;
    const nextTarget = event.relatedTarget;
    if (nextTarget instanceof Node && dropdown.contains(nextTarget)) return;
    dropdown.open = false;
  });

  // Close Fishing Finds when a pointer click lands outside its dropdown.
  document.addEventListener('click', function (event) {
    const openDropdowns = document.querySelectorAll(
      '.bnb-full-navigation__item:is([data-menu-handle="fishing-finds"], [data-menu-handle="clothing"], [data-bnb-babes], [data-bnb-contact], [data-bnb-bulk], [data-bnb-hats]) > .bnb-full-navigation__details[open]'
    );

    openDropdowns.forEach(function (dropdown) {
      if (!event.composedPath().includes(dropdown)) {
        dropdown.open = false;
      }
    });
  }, true);

  // Also allow keyboard users to dismiss Fishing Finds with Escape.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    document.querySelectorAll(
      '.bnb-full-navigation__item:is([data-menu-handle="fishing-finds"], [data-menu-handle="clothing"], [data-bnb-babes], [data-bnb-contact], [data-bnb-bulk], [data-bnb-hats]) > .bnb-full-navigation__details[open]'
    ).forEach(function (dropdown) {
      const focusWasInside = dropdown.contains(document.activeElement);
      dropdown.open = false;
      if (focusWasInside) dropdown.querySelector('summary')?.focus();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
